import * as actionTypes from './actionTypes';
import * as interfaces from './interfaces';

interface I_GroupDetailReq {
    GroupID: string;
}
interface I_GroupAllToursReq {
    NormGroupID: string;
}

interface I_GroupAllCalendarReq {
    NormGroupID: string;
    GoDateStart?: string;
    GoDateEnd?: string;
    TourID?: string;
}

interface I_TodayMoreReq {
    NormGroupID: string;
    GroupID?: string;
    GoDate: string;
}
interface I_PriceInfoReq {
    GroupID: string;
}

// interface I_SkiReq {
//     GroupID: string;
// }

interface I_StationInfoReq {
    GroupID: string;
}
interface I_FlightInfoReq {
    NormGroupID: string;
    GroupID: string;
    GoDate: string;
}

export const setGroupDetailSync = (payload: any) => ({
    type: actionTypes.SET_GROUPDETAIL_SYNC,
    payload,
});

export const setGroupDetail = (payload: I_GroupDetailReq) => ({
    type: actionTypes.SET_GROUPDETAIL,
    payload,
});

export const setGroupDetailSUCCESS = (payload: any) => ({
    type: actionTypes.SET_GROUPDETAIL_SUCCESS,
    payload,
});

export const setGroupAllTours = (payload: I_GroupAllToursReq) => ({
    type: actionTypes.SET_GROUPALLTOURS,
    payload,
});

export const setGroupAllToursSUCCESS = (payload: any) => ({
    type: actionTypes.SET_GROUPALLTOURS_SUCCESS,
    payload,
});

export const setGroupAllCalendar = (payload: I_GroupAllCalendarReq) => ({
    type: actionTypes.SET_GROUPALLCALENDAR,
    payload,
});

export const setGroupAllCalendarSUCCESS = (payload: any) => ({
    type: actionTypes.SET_GROUPALLCALENDAR_SUCCESS,
    payload,
});

export const setTodayMore = (payload: I_TodayMoreReq) => ({
    type: actionTypes.SET_TODAYMORE,
    payload,
});

export const setTodayMoreSUCCESS = (payload: any) => ({
    type: actionTypes.SET_TODAYMORE_SUCCESS,
    payload,
});

export const setPricesInfo = (payload: I_PriceInfoReq) => ({
    type: actionTypes.SET_PRICESINFO,
    payload,
});

export const setPricesInfoSUCCESS = (payload: any) => ({
    type: actionTypes.SET_PRICESINFO_SUCCESS,
    payload,
});

// export const setSki = (payload: I_SkiReq) => ({
//     type: actionTypes.SET_SKI,
//     payload,
// });

// export const setSkiSUCCESS = (payload: any) => ({
//     type: actionTypes.SET_SKI_SUCCESS,
//     payload,
// });

export const setStationInfo = (payload: I_StationInfoReq) => ({
    type: actionTypes.SET_STATIONINFO,
    payload,
});

export const setStationInfoSUCCESS = (payload: any) => ({
    type: actionTypes.SET_STATIONINFO_SUCCESS,
    payload,
});

export const setFlightInfo = (payload: I_FlightInfoReq) => ({
    type: actionTypes.SET_FLIGHTINFO,
    payload,
});

export const setFlightInfoSUCCESS = (payload: any) => ({
    type: actionTypes.SET_FLIGHTINFO_SUCCESS,
    payload,
});

export const setCallJson = (payload: any) => ({
    type: actionTypes.SET_CALLJSON,
    payload,
});

export const setCallJsonSUCCESS = (payload: any) => ({
    type: actionTypes.SET_CALLJSON_SUCCESS,
    payload,
});

export const setCalendarGroupsMode = (payload: boolean) => ({
    type: actionTypes.SET_CALENDARGROUPS_MODE,
    payload,
});

export const setCalendarGroupsMonth = (payload: string) => ({
    type: actionTypes.SET_CALENDARGROUPS_MONTH,
    payload,
});

export const setCalendarGuaranteed = (payload: boolean) => ({
    type: actionTypes.SET_CALENDARGROUPS_GUARANTEED,
    payload,
});

export const setCalendarGuaranteedChecked = (payload: boolean) => ({
    type: actionTypes.SET_CALENDARGROUPS_GUARANTEEDCHECKED,
    payload,
});

export const setCalendarParmIsEnsureGroup = (payload: boolean) => ({
    type: actionTypes.SET_CALENDARGROUPS_PARMISENSUREGROUP,
    payload,
});

export const setIsHeaderShow = (payload: any) => ({
    type: actionTypes.SET_ISHEADERSHOW,
    payload,
});

export const setCurrentTourID = (payload: any) => ({
    type: actionTypes.SET_CURRENTTOURID,
    payload,
});

export const setSchedulesActive = (payload: any) => ({
    type: actionTypes.SET_SCHEDULESACTIVE,
    payload,
});

export const setIsSearchPanelFixed = (payload: any) => ({
    type: actionTypes.SET_ISSEARCHPANELFIXED,
    payload,
});

export type I_GroupDetailAction = ReturnType<typeof setGroupDetail>;
export type I_GroupAllToursAction = ReturnType<typeof setGroupAllTours>;
export type I_GroupAllCalendarAction = ReturnType<typeof setGroupAllCalendar>;
export type I_TodayMoreAction = ReturnType<typeof setTodayMore>;
export type I_PricesInfoAction = ReturnType<typeof setPricesInfo>;
// export type I_SkiAction = ReturnType<typeof setSki>;
export type I_StationInfoAction = ReturnType<typeof setStationInfo>;
export type I_FlightInfoAction = ReturnType<typeof setFlightInfo>;
export type I_CallJsonAction = ReturnType<typeof setCallJson>;
